import type { BaseModelBasicData } from '../data/model';
import { IEvent } from '../shared/EventAggregator';

export class ProductViewedEvent implements IEvent {
  constructor(
    public readonly product: BaseModelBasicData,
    public readonly configurationCode: string | undefined,
  ) {}
}

export class RequestQuoteInitiatedEvent implements IEvent {
  constructor(
    public readonly product: BaseModelBasicData,
    public readonly configurationCode: string | undefined,
    public readonly currencyCode: string,
  ) {}
}
